import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { IKPI } from '../../../../../../model/measure/IMeasure';
import ModalKPI from './components/ModalKPI';
import ItemKPI from './components/ItemKPI';
import { MeasureService } from '../../service';
import { ErrorToast, WarningToast } from '../../../../../../utils/toasters';
import { IParams } from '../../../../../../model/shared/IParams';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../store/rootReducer';
import { AccessRightEnum } from '../../../../../../enum/AccessRightEnum';
import EmptyState from '../../../../../../shared/components/placeholder/EmptyState';

interface ICardKPI {
    additionalKpi?: IKPI[];
    setTriggerSummaryData: (...args: any) => void;
}

export default function CardRightKPI({ additionalKpi, setTriggerSummaryData }: ICardKPI) {
    const [kpis, setKpis] = useState<IKPI[] | undefined>([]);
    const [modalData, setModalData] = useState({ show: false });
    const { id } = useParams<keyof IParams>();
    const { t } = useTranslation();

    const { accessRights } = useSelector((authState: IAllStates) => authState.auth.user);

    const addKPI = () => {
        const checkedKpis = kpis?.map(kpi => {
            if (kpi.title === '' && kpi.validtitle) {
                kpi.validtitle.isValid = false;
                kpi.validtitle.startValid = true;
            }
            if (kpi.value === '' && kpi.validvalue) {
                kpi.validvalue.isValid = false;
                kpi.validvalue.startValid = true;
            }
            return kpi;
        });
        setKpis(checkedKpis);
        if (checkedKpis?.some(kpi => kpi.title === '' || kpi.value === '')) {
            return WarningToast(t('general.validation.required_fields'));
        }

        const finalKPIs = kpis?.map(({ validtitle, validvalue, ...rest }) => rest);
        MeasureService.putMeasureKPI(+id!, { kpi: finalKPIs })
            .then(() => {
                setModalData(prev => ({ ...prev, show: false }));
                setTriggerSummaryData((prev: boolean) => !prev);
            })
            .catch(error => ErrorToast(error));
    };

    useEffect(() => {
        setKpis(additionalKpi);
    }, [additionalKpi]);

    return (
        <>
            <ModalKPI
                {...modalData}
                additionalKpi={additionalKpi}
                setModalData={setModalData}
                saveFunc={addKPI}
                setKpis={setKpis}
                kpis={kpis}
            />
            <div className="d-flex justify-content-between align-items-center">
                {additionalKpi?.length && !!additionalKpi[0]?.title ? (
                    <h5>{t('brand.campaign.measure.agency_defined_kpi')}</h5>
                ) : (
                    <EmptyState isHorizontalView={true} imgClass="w-40px" desc={t('brand.campaign.measure.emptyKpi')} />
                )}
                {accessRights.includes(AccessRightEnum.CAN_SET_ADDITIONAL_KPI) && (
                    <Button
                        className="btn-outline-primary"
                        onClick={() => setModalData(prev => ({ ...prev, show: true }))}
                    >
                        {t('general.button.edit')}
                    </Button>
                )}
            </div>
            <Row className="mt-2">
                {additionalKpi?.length &&
                    !!additionalKpi[0]?.title &&
                    additionalKpi?.map((kpi, index) => {
                        return (
                            <Col className="mb-2" md={4} xs={6} key={index}>
                                <ItemKPI {...kpi} />
                            </Col>
                        );
                    })}
            </Row>
        </>
    );
}
